import { BaseColor, Breakpoint, breakpointStarting, linkInline, spacing, themeColor, Typography } from '@unbounded/unbounded-components'
import styled from 'styled-components'

const startingColumns = breakpointStarting(Breakpoint.md)

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (${startingColumns}) {
    flex-direction: row;
    margin: ${spacing(2.5)} 0 ${spacing(2)};
  }
`

export const TextSection = styled.section`
  @media (${startingColumns}) {
    width: 40%;
    margin-right: 5%;
  }
`

export const Title = styled.h1`
  ${Typography.headlineLarge};
  margin-bottom: ${spacing(1.5)};
  color: ${themeColor(BaseColor.shade_60)};
`

export const Paragraph = styled.p`
  margin-bottom: ${spacing(1.5)};
  color: ${themeColor(BaseColor.shade_50)};
`

export const Link = styled.a`
  ${linkInline};
`

export const Form = styled.section`
  background: ${themeColor(BaseColor.shade_0)};
  padding: ${spacing(0.5)} ${spacing(2)} ${spacing(2)};

  @media (${startingColumns}) {
    width: 60%;
  }
`
